export const editColumnMessages = {
  addCommand: <i className="fa fa-plus" title="Incluir"></i>,
  editCommand: <i className="fa fa-edit" title="Alterar"></i>,
  deleteCommand: <i className="fa fa-trash" title="Excluir"></i>,
  commitCommand: <i className="fa fa-save" title="Salvar"></i>,
  cancelCommand: <i className="fa fa-times" title="Cancelar"></i>,
};
